module.exports = __webpack_public_path__ + "img/2.de691344.jpg";